import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "24px", viewBox: "0 -960 960 960", width: "24px", fill: "currentColor", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" }));
export default SvgArrowDown;
